module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "contact-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-padding"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer-form"
    },
    on: {
      "click": function($event) {
        return _vm.clickedRequestDemoButton('alcohol-whitepaper')
      }
    }
  }, [_vm._v("Request a demo")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product-demos"
  }, [_c('span', {
    staticClass: "product-demo"
  }, [_c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": require("../../../assets/iphone-7-white.png")
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "product-demo-video",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/avXmMnrRgmRnVFTceZ8K_patron_screencap.mp4",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])])]), _vm._v(" "), _c('Footer', {
    attrs: {
      "id": "contact-footer-form",
      "hideFooterPadding": true,
      "customHeaderText": 'Contact MikMak for a Demo'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form-inputs"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("MikMak launches Attach for alcohol eCommerce")]), _vm._v(" "), _c('img', {
    staticClass: "whitepaper-image",
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_vm._v("By 2023, the alcohol eCommerce industry is suspected to be a $6 ­- $9B market in the US. MikMak Attach for alcohol helps beer, wine and spirits brands with: ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Connecting your product inventory to digital media"), _c('br')]), _vm._v(" With MikMak, ensure your digital media only showcases retailers and marketplaces that have your SKU in stock ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Optimizing your content for eCommerce"), _c('br')]), _vm._v(" Control your Product Detail Page Experiences with MikMak, ensure no competitors surface, increase CTR and time spent ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Building & owning your shopper audiences"), _c('br')]), _vm._v(" With MikMak, measure from impression through to sale, access retailer specific, audience data in your CMP/Ads Manager for look alike prospecting and retargeting, implement DR targeting with niche audiences to drive bottom line results ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-amazon.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-cocktail-courier.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-drizly.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-gopuff.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-instacart.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-kroger.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-minibar.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-target.png",
      "alt": "target"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-reserve-bar.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-walmart.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-walmart-grocery.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-winecom.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5261edf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Whitepaper/Alcohol.vue
// module id = 476
// module chunks = 0